import React from "react";
import { Link } from "react-router-dom";

/**
 * Left-rail Community shortcuts for Social (Phase E Sprint 5.0).
 * Views use ?view= — never hash anchors that scroll the Activity feed.
 */
const NAV_ITEMS = [
  {
    key: "profile",
    label: "Community Profile",
    path: "/community/social?view=profile",
    icon: "profile",
  },
  {
    key: "posts",
    label: "My Feed",
    path: "/community/social?view=posts",
    icon: "posts",
  },
  {
    key: "following",
    label: "Following",
    path: "/community/social?view=following",
    icon: "following",
  },
  {
    key: "saved",
    label: "Saved Posts",
    path: "/community/social?view=saved",
    icon: "saved",
  },
  {
    key: "games",
    label: "Games",
    path: "/games",
    icon: "games",
  },
  {
    key: "events",
    label: "Events",
    path: "/community/events",
    icon: "events",
    soon: true,
    hidden: true,
  },
  {
    key: "groups",
    label: "Groups",
    path: "/community/social?view=groups",
    icon: "groups",
    soon: true,
    hidden: true,
  },
];

function CommunitySocialNav({ activeKey = "posts", profile = null }) {
  const visibleItems = NAV_ITEMS.filter((item) => !item.hidden);

  return (
    <nav className="community-social-nav" aria-label="Community shortcuts">
      <p className="community-social-nav__eyebrow">Community</p>
      {profile && profile.display_name ? (
        <div className="community-social-nav__identity">
          <span className="community-social-nav__name">{profile.display_name}</span>
          {profile.handle ? (
            <span className="community-social-nav__handle">@{profile.handle}</span>
          ) : (
            <span className="community-social-nav__handle community-social-nav__handle--missing">
              No public handle yet
            </span>
          )}
        </div>
      ) : null}
      <ul className="community-social-nav__list">
        {visibleItems.map((item) => {
          const isActive = item.key === activeKey;
          return (
            <li key={item.key}>
              <Link
                to={item.path}
                className={
                  "community-social-nav__link" +
                  (isActive ? " is-active" : "") +
                  (item.soon ? " is-soon" : "")
                }
                aria-current={isActive ? "page" : undefined}
              >
                <span className="community-social-nav__label">{item.label}</span>
                {item.soon ? (
                  <span className="community-social-nav__soon">Soon</span>
                ) : null}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default CommunitySocialNav;
export { NAV_ITEMS };
